<template>
  <div class="app-planning">
    <div class="columns">
      <div class="column is-one-quarter">
        <div class="buttons has-addons">
          <span v-for="duree in granulariteAffichage" :key="duree.granularity" v-if="duree.actif"
                class="button"
                :class="{ 'is-primary': criterePlanning.granularity === duree.granularity }"
                @click="updateGranularity(duree.granularity)">
            {{ duree.label }}
          </span>
        </div>
      </div>
      <div class="column is-half has-text-centered">
        <div>
          <button class="button" @click="updateDateDebut(-criterePlanning.size)">
            <b-icon icon="chevron-double-left"></b-icon>
          </button>
          <button class="button" @click="updateDateDebut(-Math.floor(criterePlanning.size / 2.0))">
            <b-icon icon="chevron-left"></b-icon>
          </button>
          <span style="min-width: 290px;display: inline-block;">
        {{ dateDebutFormattee }} - {{ dateFinFormattee }}
        </span>
          <button class="button" @click="updateDateDebut(Math.floor(criterePlanning.size / 2.0))">
            <b-icon icon="chevron-right"></b-icon>
          </button>
          <button class="button" @click="updateDateDebut(criterePlanning.size)">
            <b-icon icon="chevron-double-right"></b-icon>
          </button>
        </div>
      </div>
      <div class="column is-one-quarter" style="display: none">
        <div class="is-pulled-right">
          <a class="button" @click="modifierTypeVente(typeFull)"
            v-bind:class="{'is-primary is-outlined has-background-white has-text-primary'
            :typeVente == typeFull}">
            <b-icon icon="plus-circle-outline" ></b-icon>
            <span>Full</span>
          </a>
          <a class="button " @click="modifierTypeVente(typeAccess)"
            v-bind:class="{'is-primary is-outlined has-background-white has-text-primary'
            :typeVente == typeAccess}">
            <b-icon icon="plus-circle-outline" ></b-icon>
            <span>Access</span>
          </a>
        </div>
      </div>
    </div>
    <v-client-table ref="planningNumerique"
                    :data="data"
                    :columns="columns"
                    :options="options" class="fixed_header table-planning-numerique">
      <div slot="selected" slot-scope="props" style="text-align:center">
        <input type="checkbox" id="checkbox" :value="props.row" v-model="props.row.icon" />
      </div>
      <div slot="icon" slot-scope="props" style="text-align:center"
        :class="{'has-text-primary': props.row.selected}"
        @click="ajouterAuPanier(props.row)">
        <b-icon icon="transcribe-close"></b-icon>
      </div>
    </v-client-table>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import gestionErreur from '@/services/general/gestionErreur';
import { TEXTS, PER_PAGE_VALUE, RESULTS_PER_PAGE } from '@/configuration/clientTableConf';
import * as types from '@/store/creationOpportunite/venteNumerique-mutation-type';
import * as planningNumeriqueConf from '@/components/creationOpportunite/configuration/planningNumeriqueConf';
import planningChildRowFace from './planningChildRowFace';
import PlanningJourSvg from './planningNumeriqueJourSvg';
import PlanningSemaineSvg from './planningNumeriqueSemaineSvg';

const VenteNumerique = createNamespacedHelpers('venteNumerique');

export default {
  name: 'planning',
  data() {
    return {
      granulariteAffichage: planningNumeriqueConf.GRANULARITY,
      trad: {
        selected: '',
        icon: '',
        PanCode: '↑↓ Panneau',
        Adresse: '↑↓ Adresse',
        Planning: 'Planning',
      },
      typeFull: planningNumeriqueConf.TYPE_VENTE_FULL,
      typeAccess: planningNumeriqueConf.TYPE_VENTE_ACCESS,

    };
  },
  computed: {
    ...VenteNumerique.mapGetters({
      panneauxWithFilter: 'panneauxWithFilter',
      criterePlanning: 'criterePlanning',
      getTypeVente: 'typeVente',
    }),
    typeVente: {
      get() {
        return this.getTypeVente;
      },
      set(value) {
        this.setTypeVente(value);
      },
    },
    data() {
      const panneaux = this.panneauxWithFilter;
      return panneaux;
    },
    dateDebutFormattee() {
      return this.criterePlanning.dateStart.format('LL');
    },
    dateFinFormattee() {
      return this.criterePlanning.dateEnd.format('LL');
    },
    columns() {
      return ['icon', 'code', 'adresseCommercialeLibelle1', 'planning'];
    },
    options() {
      let currentPlanning = PlanningJourSvg;
      if (this.criterePlanning.granularity === 'week') {
        currentPlanning = PlanningSemaineSvg;
      }
      return {
        headings: {
          selected: this.trad.icon,
          icon: this.trad.icon,
          code: this.trad.PanCode,
          adresseCommercialeLibelle1: this.trad.Adresse,
          planning(h) {
            return this.getPlanningHeader(h);
          },
        },
        filterable: false,
        perPageValues: PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE,
        texts: TEXTS,
        uniqueKey: 'num',
        childRow: planningChildRowFace,
        templates: {
          planning: currentPlanning,
        },
        columnsClasses: {
          icon: 'colonneBoutonFaceLcListe45px',
          selected: 'colonneBoutonFaceLcListe45px',
          code: 'ellipsis ventesNumeriquePlanningTailleColonneCode',
          adresseCommercialeLibelle1: 'ellipsis ventesNumeriquePlanningTailleColonneAdresse',
          planning: 'ventesNumeriquePlanningTailleColonnePlanning',
        },
      };
    },
  },
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    ...VenteNumerique.mapActions({
      actionsGestionPanier: 'gestionPanier',
    }),
    ...VenteNumerique.mapMutations({
      setPanneauSelected: types.SET_PANNEAU_SELECTED,
    }),
    ajouterAuPanier(face) {
      const tarification = 100 + 1;
      this.typeVente = 100;
      this.setPanneauSelected({
        panNum: face.num,
        value: true,
      });
      this.actionsGestionPanier({
        panNum: face.num,
        periode: 'du ' + this.criterePlanning.dateStart.format('DD/MM/YYYY') + ' au ' + this.criterePlanning.dateEnd.format('DD/MM/YYYY'),
        tarification: tarification,
      });
    },
    ...VenteNumerique.mapActions({
      actionsChangementDateDebutPlanning: 'changementDateDebutPlanning',
      actionsRecuperationPanneaux: 'recuperationPanneaux',
    }),
    ...VenteNumerique.mapMutations({
      setTypeVente: types.SET_TYPE_VENTE,
    }),
    recherchePanneaux() {
      this.valid = true;
      const loadingComponent = this.$buefy.loading.open({ container: null });
      this.actionsRecuperationPanneaux({ valid: this.valid, codeFace: '',
      }).then(() => {
        loadingComponent.close();
      }).catch((e) => {
        loadingComponent.close();
        gestionErreur('Erreur lors de la recherche des panneaux numériques liée à la date', e);
      });
    },
    modifierTypeVente(type) {
      if (this.typeVente === type) {
        this.typeVente = planningNumeriqueConf.SANS_TYPE_VENTE;
        return;
      }
      this.typeVente = type;
    },
    handleResize() {
      this.actionsChangementDateDebutPlanning(
        {
          debut: this.criterePlanning.dateStart,
          granularity: this.criterePlanning.granularity,
        },
      );
    },
    updateGranularity(granularity) {
      this.actionsChangementDateDebutPlanning(
        {
          debut: this.criterePlanning.dateStart,
          granularity,
        },
      );
    },
    async updateDateDebut(decalage) {
      await this.actionsChangementDateDebutPlanning(
        {
          debut: this.criterePlanning.dateStart.clone().add(decalage, this.criterePlanning.unit),
          granularity: this.criterePlanning.granularity,
        },
      );
      await this.recherchePanneaux();
    },
    getPlanningHeader(h) {
      let content;
      switch (this.criterePlanning.granularity) {
        case 'week':
          content = this.getPlanningHeaderSemaine(h);
          break;
        case 'day':
        default:
          content = this.getPlanningHeaderJour(h);
          break;
      }
      return h('svg', {
        attrs: {
          width: '100%',
          height: '38px',
        },
      },
      content);
    },
    getPlanningHeaderSemaine(h) {
      const lineAndTextArray = [];
      const nombreJoursTotal = this.criterePlanning.days;
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateStart.clone().add(nombreJoursTotal, 'days');
      let dateVar = dateStart.clone();
      let oldMonth = 'empty';
      while (dateVar <= dateEnd) {
        const offset = dateVar.diff(dateStart, 'days') / nombreJoursTotal * 100;
        if (oldMonth !== dateVar.format('MMMM')) {
          lineAndTextArray.push(h('text', {
            attrs: {
              x: (offset + 0.5) + '%',
              y: '25%',
              fill: '#5e738b',
              'dominant-baseline': 'central',
              'text-anchor': 'start',
              'font-size': '12px',
            },
          }, dateVar.format('MMMM')));
        }
        if (!dateVar.isSame(dateStart)) {
          lineAndTextArray.push(h('line', {
            attrs: {
              x1: offset + '%',
              y1: '50%',
              x2: offset + '%',
              y2: '100%',
              style: 'stroke: #E3E1F2;stroke-width: 2px',
            },
          }));
        }
        lineAndTextArray.push(h('text', {
          attrs: {
            x: (offset + 0.5) + '%',
            y: '75%',
            fill: '#5e738b',
            'dominant-baseline': 'central',
            'text-anchor': 'start',
            'font-size': '12px',
          },
        }, 'S' + dateVar.format('W')));
        oldMonth = dateVar.format('MMMM');
        dateVar = dateVar.add(7, 'days');
      }
      return lineAndTextArray;
    },
    getPlanningHeaderJour(h) {
      const lineAndTextArray = [];
      const nombreJoursTotal = this.criterePlanning.days;
      const dateStart = this.criterePlanning.dateStart;
      const dateEnd = this.criterePlanning.dateStart.clone().add(nombreJoursTotal, 'days');
      let dateVar = dateStart.clone();
      let oldMonth = 'empty';
      while (dateVar <= dateEnd) {
        const offset = dateVar.diff(dateStart, 'days') / nombreJoursTotal * 100;
        if (oldMonth !== dateVar.format('MMMM')) {
          lineAndTextArray.push(h('text', {
            attrs: {
              x: (offset + 0.5) + '%',
              y: '25%',
              fill: '#5e738b',
              'dominant-baseline': 'central',
              'text-anchor': 'start',
              'font-size': '12px',
            },
          }, dateVar.format('MMMM')));
        }
        if (!dateVar.isSame(dateStart)) {
          lineAndTextArray.push(h('line', {
            attrs: {
              x1: offset + '%',
              y1: '50%',
              x2: offset + '%',
              y2: '100%',
              style: 'stroke: #E3E1F2;stroke-width: 2px',
            },
          }));
        }
        lineAndTextArray.push(h('text', {
          attrs: {
            x: (offset + 0.5) + '%',
            y: '75%',
            fill: '#5e738b',
            'dominant-baseline': 'central',
            'text-anchor': 'start',
            'font-size': '12px',
          },
        }, dateVar.format('D')));
        oldMonth = dateVar.format('MMMM');
        dateVar = dateVar.add(1, 'days');
      }
      return lineAndTextArray;
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteNumerique/recherche/planning.vue